export default{
    DATA_COLLECTION_LINK :"https://culturebiedev-uploadbucket.s3.amazonaws.com/samplefiles/VerySimpleSurvey.csv"
}